import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, of, startWith } from 'rxjs';
import { AuthActions } from '@components/auth/auth.actions';
import { ReportViewTraitResultActions } from './result.actions';
import { ReportViewTraitResultService } from './result.service';

/**
 * Report View Trait Result Effects.
 */
@Injectable()
export class ReportViewTraitResultEffects extends ReportViewTraitResultService {
  private readonly actions = inject(Actions);

  readonly onAuthLogout_SwitchProfile = createEffect(
    () => {
      return this.actions.pipe(
        ofType(AuthActions.logout, AuthActions.switchProfile),
        map(() => ReportViewTraitResultActions.reset())
      );
    },
    { dispatch: true }
  );

  readonly onFetchReport = createEffect(
    () => {
      return this.actions.pipe(
        ofType(ReportViewTraitResultActions.fetchReport),
        mergeMap(({ id, reportType }) => {
          return this.report({ id, reportType }).pipe(
            mergeMap((data) =>
              of(
                ReportViewTraitResultActions.setReport(data),
                ReportViewTraitResultActions.setLoading({ loading: false })
              )
            ),
            catchError((error) => {
              // eslint-disable-next-line no-console
              console.error('onFetchReport', error);
              return of(
                ReportViewTraitResultActions.setReport({}),
                ReportViewTraitResultActions.setLoading({ loading: false })
              );
            }),
            startWith(
              ReportViewTraitResultActions.setLoading({ loading: true })
            )
          );
        })
      );
    },
    { dispatch: true }
  );
}
